export default "__VITE_ASSET__r5qCLll2__"